import { render, staticRenderFns } from "./AamsGiftRegInStorage.vue?vue&type=template&id=46602a32&scoped=true&"
import script from "./AamsGiftRegInStorage.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegInStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46602a32",
  null
  
)

export default component.exports